import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "animate.css";
import { useSelector } from "react-redux";
import StartInfoModal from "../StartInfoModal";
import ScrollableCard from "../../../../SharedComponents/ScrollableCard";
import AppCardItem from "./AppCardItem";
import { useLocation } from "react-router-dom";

export function AppCard({ isOnlyFinished, isOnlyNonFinished, isMobile }) {
  const candidateData = useSelector((state) => state.userDash.candidateData);

  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const { state } = useLocation();

  useEffect(() => {
    if (state?.company && state?.application && state?.ticketId) {
      setSelectedAssessment({ company: state.company, application: state.application, ticketId: state.ticketId });
    }
  }, [state]);

  const CreateAppCardUiElement = (application, company, ticketId, i) => {
    if (isOnlyFinished && application.sessionsData?.isFinished !== true) {
      return;
    }
    if (isOnlyNonFinished && application.sessionsData?.isFinished !== false && application.sessionsData !== null) {
      return;
    }

    return (
      <Col
        key={i}
        xs={12}
        md={6}
        xl={4}
        xxl={3}
        xxxl={2}
        className="animate__animated animate__fadeInDown animate__faster mb-4"
        style={{
          minWidth: "350px",
        }}
      >
        <AppCardItem
          application={application}
          setSelectedAssessment={setSelectedAssessment}
          company={company}
          ticketId={ticketId}
          isMobile={isMobile}
        ></AppCardItem>
      </Col>
    );
  };

  const HandleTicket = (ticket, company, ticketIndex) => {
    let apps = [];
    ticket.inventories?.forEach((inventory, i) => {
      apps.push(CreateAppCardUiElement(inventory, company, ticket.ticketId, `I${ticketIndex}${i}`));
    });
    ticket.tests?.forEach((test, i) => {
      apps.push(CreateAppCardUiElement(test, company, ticket.ticketId, `T${ticketIndex}${i}`));
    });
    ticket.surveys?.forEach((survey, i) => {
      apps.push(CreateAppCardUiElement(survey, company, ticket.ticketId, `S${ticketIndex}${i}`));
    });
    return apps;
  };

  return (
    <>
      <StartInfoModal
        selectedAssessment={selectedAssessment}
        setSelectedAssessment={setSelectedAssessment}
      ></StartInfoModal>
      <ScrollableCard>
        {candidateData?.map((candidate, i) => {
          const company = {
            companyName: candidate.companyName,
            companyLogoImageName: candidate.companyLogoImageName,
            candidateId: candidate.candidateId,
            companyId: candidate.companyId,
            hasDemography: candidate.hasDemography,
          };

          return (
            <div key={i}>
              <Row className={"mx-0 mt-3 "}>
                {candidate?.tickets?.map((ticket, i) => HandleTicket(ticket, company, i))}
              </Row>
            </div>
          );
        })}
      </ScrollableCard>
    </>
  );
}
